<template>
    <div class="detailBread">
        <router-link to="/home" class="linked">首页</router-link>
        <span>/</span>
        <a href="javascript:;" class="linked" @click="$router.back" >{{courseInfo.name}}</a>
        <span>/</span>
        <a>订单确认</a>
    </div>
</template>

<script>
export default {
    computed: {
        courseInfo() {
            return this.$store.state.courseDetail;
        },
    },
}
</script>

<style scoped>
.detailBread {
    display: block;
    height: 80px;
    width: 1200px;
    margin: 0 auto;
    line-height: 80px;
}

.detailBread a {
    display: inline-block;
    color: #151515;
    font-size: 14px;
}

.detailBread a.linked {
    color: #8C8C8C;
    font-size: 14px;
}

.detailBread a.linked:hover {
    color: var(--link-hover-color)
}

.detailBread span {
    display: inline-block;
    color: #8C8C8C;
    font-size: 14px;
    margin-left: 5px;
    padding-right: 5px;
}
</style>